import { Box, HStack, Text, Spinner } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { pxToRem } from '@duke-hq/ui/constants/scalable';

export default function ProgressCard({
  backgroundColour,
  label,
  value,
  to,
}: {
  backgroundColour: string;
  label: string;
  value?: string | number;
  to?: string;
}) {
  const navigate = useNavigate();

  return (
    <HStack
      borderRadius="2xl"
      py="1"
      pl="3"
      pr="2"
      gap="1"
      flex="1"
      minHeight={pxToRem(40)}
      alignItems="center"
      justifyContent="space-between"
      backgroundColor={backgroundColour}
      {...(to !== undefined && {
        onClick: () => navigate(to),
        role: 'link',
        cursor: 'pointer',
      })}
    >
      <Box w="full">
        <Text
          fontSize="sm"
          lineHeight="5"
          letterSpacing="0%"
          verticalAlign="bottom"
          fontWeight="medium"
          color="fg.inverse-subtle"
        >
          {label}
        </Text>
      </Box>
      <Box w="full">
        {value === undefined ? (
          <Spinner size="sm" verticalAlign="middle" float="right" m={1} />
        ) : (
          <Text
            fontSize="2xl"
            lineHeight="8"
            letterSpacing="0%"
            textAlign="right"
            verticalAlign="middle"
            fontWeight="medium"
            color="fg.inverse"
          >
            {value}
          </Text>
        )}
      </Box>
    </HStack>
  );
}
